import React from "react";

import Communications from "components/Communications";

const CommunicationsTab = ({ history, match }) => (
  <Communications history={history} match={match} />
);

export default CommunicationsTab;
